import BillingApi from '@/services/rest/bemob/billing';
import UserApi from '@/services/rest/bemob/user';
import store from '@/store';
import api from '@/services/utils/base';

export class AppExeptionsDialogsApi {

  error: boolean = false;
  loading: boolean = false;
  tableLoading: boolean = false;

  billingApi: BillingApi = new BillingApi();
  userApi: UserApi = new UserApi();

  collectUnpaidInvoices() {
    this.loading = true;

    return this.billingApi.collectUnpaidInvoices()
      .then((res: any) => {
        return Promise.resolve(res)
      })
      .catch((error: any) => {
        return Promise.reject(error)
      })
      .finally(() => {
        this.loading = false;
      });
  }

  getUnpaidInvoices(): Promise<Billing.UnpaidData> {
    return this.billingApi.getUnpaidInvoices()
      .then((res: any) => {
        return Promise.resolve(res.data.payload)
      })
      .catch((error: any) => {
        return Promise.reject(error)
      })
  }

  payPalCapture(payload:{ orderID:string}){
    return api.post('billing/paypal/capture',payload)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  updateUser({ isLoadLanguage = true } = {}) {
    this.loading = true;

    return this.userApi.getUser({ isLoadLanguage })
      .then((res: any) => {
        store.commit('updateUser', res);
        return Promise.resolve(res);
      }).catch((err: any) => {
        return Promise.reject(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  putUser(payload: any) {
    this.loading = true;

    return this.userApi.putUser(payload)
      .then((res: any) => {
        store.commit('updateUser', res);
        return Promise.resolve(res);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  shakeUser() {
    const payload = {
      firstName: store.state.user.firstName
    }

    return this.userApi.putUser(payload)
      .then((res: any) => {
        return Promise.resolve(res);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      })
  }
}

export default new AppExeptionsDialogsApi();